import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import QuizViewer from './src/components/QuizViewer';
import './src/index.css';


const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

// Detectar se é uma URL de quiz viewer (formato: /slug)
const path = window.location.pathname;
const hostname = window.location.host;
// Função para extrair host de uma URL (remove protocolo e path)
const extractHostFromUrl = (url: string): string => {
  try {
    const urlObj = new URL(url);
    return urlObj.host; // Retorna 'quiz.accesso.pro' de 'https://quiz.accesso.pro/'
  } catch {
    // Se falhar parse, tenta remover protocolo manualmente
    return url.replace(/^https?:\/\//, '').replace(/\/.*$/, '');
  }
};

// Extrair domínio principal de VITE_APP_URL
const appUrl = (import.meta.env.VITE_APP_URL || 'http://localhost:5176').trim();
const defaultDomain = extractHostFromUrl(appUrl);

// Domínio principal: comparação exata com a configuração
const isMainDomain = hostname === defaultDomain;

const isExcludedPath = path.includes('/dashboard') ||
  path.includes('/ai') ||
  path.includes('/settings') ||
  path.includes('/stats') ||
  path.includes('/preview') ||
  path.includes('/leads');

// QuizViewer é ativado se:
// 1. Não for uma rota administrativa (dashboard, ai, etc)
// 2. E: (Caminho não é a raiz) OU (É um domínio personalizado/subdomínio)
// Debug log para ajudar a entender o roteamento
if (import.meta.env.DEV) {
  console.log('Routing Debug:', {
    path,
    hostname,
    defaultDomain,
    isMainDomain,
    isExcludedPath
  });
}

const isQuizViewer = !isExcludedPath && (path.length > 1 || !isMainDomain);

const root = ReactDOM.createRoot(rootElement);

// StrictMode apenas em desenvolvimento (causa renderizações duplas em produção)
const AppComponent = isQuizViewer ? <QuizViewer /> : <App />;

root.render(
  import.meta.env.DEV ? (
    <React.StrictMode>
      {AppComponent}
    </React.StrictMode>
  ) : (
    AppComponent
  )
);
